import React from "react";
import { Card, CardContent, Divider, Grid, Typography } from "@mui/material";
import SessionStatusChip from "./SessionStatusChip";

function fmt(value) {
  if (value === undefined || value === null || value === "") return "—";
  return String(value);
}

function fmtDate(value) {
  if (!value) return "—";
  return new Date(value).toLocaleString();
}

function Item({ label, value }) {
  return (
    <div>
      <Typography sx={{ color: "#64748b", fontSize: 13, fontWeight: 700, mb: 0.5 }}>
        {label}
      </Typography>
      <Typography sx={{ color: "#0f172a", fontWeight: 700 }}>
        {value}
      </Typography>
    </div>
  );
}

export default function DripSessionDetailsCard({ session }) {
  if (!session) return null;

  return (
    <Card elevation={0} sx={{ borderRadius: 4, border: "1px solid #e2e8f0" }}>
      <CardContent sx={{ p: 3 }}>
        <Typography variant="h5" sx={{ fontWeight: 800, mb: 2 }}>
          Session Details
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <Item label="Session ID" value={fmt(session.session_id || session.drip_session_id)} />
          </Grid>
          <Grid item xs={12} md={4}>
            <Item label="Patient Name" value={fmt(session.patient_name)} />
          </Grid>
          <Grid item xs={12} md={4}>
            <Item label="Patient UID" value={fmt(session.patient_uid)} />
          </Grid>

          <Grid item xs={12} md={4}>
            <Item label="Fluid Serial Number" value={fmt(session.fluid_serial_number)} />
          </Grid>
          <Grid item xs={12} md={4}>
            <Item label="Hospital Name" value={fmt(session.hospital_name)} />
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography sx={{ color: "#64748b", fontSize: 13, fontWeight: 700, mb: 0.5 }}>
              Status
            </Typography>
            <SessionStatusChip status={session.status} />
          </Grid>

          <Grid item xs={12} md={4}>
            <Item label="Start Time" value={fmtDate(session.start_at)} />
          </Grid>
          <Grid item xs={12} md={4}>
            <Item label="End Time" value={fmtDate(session.end_at)} />
          </Grid>
          <Grid item xs={12} md={4}>
            <Item label="Last Data Time" value={fmtDate(session.last_data_at)} />
          </Grid>
        </Grid>

        <Divider sx={{ my: 3 }} />

        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <Item label="Paused At" value={fmtDate(session.paused_at)} />
          </Grid>
          <Grid item xs={12} md={4}>
            <Item label="Resumed At" value={fmtDate(session.resumed_at)} />
          </Grid>
          <Grid item xs={12} md={4}>
            <Item label="Completed At" value={fmtDate(session.completed_at)} />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}